import { inject, Injectable } from '@angular/core';
import { UserService } from '@features/sign-in/services/user.service';
import { ROOT } from '@shared/constants/routing-paths.constants';
import { Router } from '@angular/router';

@Injectable()
export class NoAuthGuard {
  private userService = inject(UserService);
  private router = inject(Router);

  canActivate() {
    if (this.userService.isLoggedIn) {
      void this.router.navigateByUrl(ROOT, { replaceUrl: true });
      return false;
    }
    return true;
  }
}
